import React, { useState, useEffect } from "react";
import {
  addCar,
  cleanData,
  clearEditCarID,
  editCar,
} from "../../redux/Slice/formSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SuccessModal from "./PaymentSuccessModal";
import { getUserDetail } from "../../redux/Slice/authSlice";
import { stripeSessionGet } from "../../redux/Slice/bookingSlice";
import noDataImg from "../../assets/no-data-found.png";
import ClipLoader from "react-spinners/ClipLoader";

const GpsPaymentRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const step = useSelector((state) => state?.form?.step);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const editCarID = useSelector((state) => state?.form?.editCarID);
  const editCarResponse = useSelector((state) => state?.form?.editCarResponse);
  const carDetails = useSelector((state) => state?.form?.carDetails);
  const PersonalDetails = useSelector((state) => state?.form?.PersonalDetails);
  const driverDetails = useSelector((state) => state?.form?.driverDetails);
  const carInsurance = useSelector((state) => state?.form?.carInsurance);
  const location = useSelector((state) => state?.form?.location);
  const addCarData = useSelector((state) => state?.form?.addCarData);
  const gpsPayment = useSelector((state) => state?.auth?.gpsPayment);
  const { loginId } = useSelector((state) => state?.auth);
  const [isPaid, setIsPaid] = useState(false);
  const [base64Data, setBase64Data] = useState({});
  const [noData, setNoData] = useState(false);

  // let base64Data = {}
  // const [personalDetail, setPersonalDetail] = useState({
  //   fullName: "",
  //   email: "",
  //   phone: "",
  //   address: "",
  //   identityFront: "",
  //   identityBack: "",
  // });

  useEffect(() => {
    if (addCarData?.success === true) {
      toast(addCarData?.message);
      dispatch(cleanData());
      setTimeout(() => {
        navigate("/myvehicle");
      }, 2000);
    }
    if(addCarData?.success === false)
    {
      toast(addCarData?.message);
    }
  }, [addCarData]);
  useEffect(() => {
    // base64Data = {
    //     ...base64Data,
    //     identityFront: (personalDetail?.identityFront) ? base64StringToSyntheticFile(personalDetail?.identityFront) : userDetail?.data?.identityFront,
    //     identityBack: (personalDetail?.identityBack) ? base64StringToSyntheticFile(personalDetail?.identityBack) : userDetail?.data?.identityBack,
    //     carFrontImg: (carDetails?.carFrontImg) ? base64StringToSyntheticFile(carDetails?.carFrontImg?.base64) : "",
    //     carBackImg: (carDetails?.carBackImg) ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64) : "",
    //     carLeftImg: (carDetails?.carLeftImg) ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64) : "",
    //     carRightImg: (carDetails?.carRightImg) ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64) : "",
    //     numberPlateImg: (carDetails?.numberPlateImg) ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64) : "",
    //     IDfront: (driverDetails?.IDfront) ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64) : "",
    //     IDback: (driverDetails?.IDback) ? base64StringToSyntheticFile(driverDetails?.IDback?.base64) : "",
    //     licenceImg: (driverDetails?.licenceImg) ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64) : "",
    // }\

    setBase64Data({
      ...base64Data,
      // identityFront: personalDetail?.identityFront
      //   ? base64StringToSyntheticFile(personalDetail?.identityFront)
      //   : userDetail?.data?.identityFront,
      // identityBack: personalDetail?.identityBack
      //   ? base64StringToSyntheticFile(personalDetail?.identityBack)
      //   : userDetail?.data?.identityBack,

      /* not updateing ids that's why commemtn above code and use base64 images from redux to convert and send them to backend  */

      identityFront: PersonalDetails?.identityFront
        ? base64StringToSyntheticFile(PersonalDetails?.identityFront)
        : userDetail?.data?.identityFront,
      identityBack: PersonalDetails?.identityBack
        ? base64StringToSyntheticFile(PersonalDetails?.identityBack)
        : userDetail?.data?.identityBack,
      // carFrontImg: (carDetails?.carFrontImg) ? base64StringToSyntheticFile(carDetails?.carFrontImg?.base64) : "",
      carFrontImg: carDetails?.carFrontImg
        ? carDetails.carFrontImg.base64
          ? base64StringToSyntheticFile(carDetails.carFrontImg.base64)
          : carDetails.carFrontImg
        : null,

      // carBackImg: (carDetails?.carBackImg) ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64) : "",
      carBackImg: carDetails?.carBackImg
        ? carDetails.carBackImg.base64
          ? base64StringToSyntheticFile(carDetails?.carBackImg?.base64)
          : carDetails?.carBackImg
        : "",
      carLeftImg: carDetails?.carLeftImg
        ? carDetails?.carLeftImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64)
          : carDetails?.carLeftImg
        : "",
      carRightImg: carDetails?.carRightImg
        ? carDetails?.carRightImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64)
          : carDetails?.carRightImg
        : "",
      carSeatsImg: carDetails?.carSeatsImg
        ? carDetails?.carSeatsImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carSeatsImg?.base64)
          : carDetails?.carSeatsImg
        : "",
        carInteriorImg: carDetails?.carInteriorImg
        ? carDetails?.carInteriorImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carInteriorImg?.base64)
          : carDetails?.carInteriorImg
        : "",
      carDashboardImg: carDetails?.carDashboardImg
        ? carDetails?.carDashboardImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carDashboardImg?.base64)
          : carDetails?.carDashboardImg
        : "",
      carChassisImg: carDetails?.carChassisImg
        ? carDetails?.carChassisImg?.base64
          ? base64StringToSyntheticFile(carDetails?.carChassisImg?.base64)
          : carDetails?.carChassisImg
        : "",
      numberPlateImg: carDetails?.numberPlateImg
        ? carDetails?.numberPlateImg?.base64
          ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64)
          : carDetails?.numberPlateImg
        : "",
      IDfront: driverDetails?.IDfront
        ? driverDetails?.IDfront?.base64
          ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64)
          : driverDetails?.IDfront
        : "",
      IDback: driverDetails?.IDback
        ? driverDetails?.IDback?.base64
          ? base64StringToSyntheticFile(driverDetails?.IDback?.base64)
          : driverDetails?.IDback
        : "",
      licenceImg: driverDetails?.licenceImg
        ? driverDetails?.licenceImg?.base64
          ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64)
          : driverDetails?.licenceImg
        : "",
      diskImage: carInsurance?.diskImage
        ? carInsurance?.diskImage?.base64
          ? base64StringToSyntheticFile(carInsurance?.diskImage?.base64)
          : carInsurance?.diskImage
        : "",
      // carLeftImg: (carDetails?.carLeftImg) ? base64StringToSyntheticFile(carDetails?.carLeftImg?.base64) : "",
      // carRightImg: (carDetails?.carRightImg) ? base64StringToSyntheticFile(carDetails?.carRightImg?.base64) : "",
      // numberPlateImg: (carDetails?.numberPlateImg) ? base64StringToSyntheticFile(carDetails?.numberPlateImg?.base64) : "",
      // IDfront: (driverDetails?.IDfront) ? base64StringToSyntheticFile(driverDetails?.IDfront?.base64) : "",
      // IDback: (driverDetails?.IDback) ? base64StringToSyntheticFile(driverDetails?.IDback?.base64) : "",
      // licenceImg: (driverDetails?.licenceImg) ? base64StringToSyntheticFile(driverDetails?.licenceImg?.base64) : "",
    });

    // setBase64Data({
    //     identityFront: (personalDetail?.identityFront) ? base64StringToSyntheticFile(personalDetail?.identityFront) : userDetail?.data?.identityFront,
    //     identityBack: (personalDetail?.identityBack) ? base64StringToSyntheticFile(personalDetail?.identityBack) : userDetail?.data?.identityBack
    // })
  }, [step, carDetails, PersonalDetails]);

  useEffect(() => {
    if (editCarResponse?.success === true) {
      toast(editCarResponse?.message);
      dispatch(cleanData());
      dispatch(clearEditCarID());
      navigate("/myvehicle", { replace: true });
    }
  }, [editCarResponse]);

  useEffect(() => {
    async function gpsPaymentCheckHandler() {
      if (Object.keys(base64Data).length >= 8) {
        const data = await dispatch(getUserDetail(loginId));
        if (data?.payload?.data?.stripeSessionId) {
          const stripeSession = await dispatch(
            stripeSessionGet(data?.payload?.data?.stripeSessionId)
          );
          if (stripeSession?.payload?.data?.data?.payment_status === "paid") {
            setIsPaid(true);
            createCarHandler();
          }
        } else {
          setNoData(true);
        }
      }
    }
    gpsPaymentCheckHandler();

    // if (Object.keys(base64Data).length >= 8) {
    //   createCarHandler();
    // }
    return () => {
      //   dispatch(cleanData());
    };
  }, [base64Data]);
  function base64StringToSyntheticFile(
    base64String,
    fileName = "image.png",
    fileType = "image/png"
  ) {
    if (base64String) {
      if (base64String.includes("base64")) {
        // Split the base64 string by comma to separate metadata from data
        const parts = base64String.split(",");
        // Extract the metadata part which contains the data type and base64 prefix
        const metadata = parts[0];
        // Split the metadata part by semicolon to separate data type and parameters
        const metadataParts = metadata.split(";");
        // Extract the data type which contains the MIME type and encoding
        const dataType = metadataParts[0];
        // Extract the file extension from the data type
        const extension = dataType.split("/")[1];

        fileType = dataType;
        fileName = `image.${extension}`;
        // Check if the base64 string contains a data URI prefix
        let str = base64String.substr(base64String.indexOf(",") + 1);
        // Log the base64 string before decoding

        // Convert base64 string to Blob
        const byteCharacters = atob(str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });

        // Create synthetic file object
        const syntheticFile = new File([blob], fileName, {
          type: fileType,
        });

        return syntheticFile;
      } else {
        return base64String;
      }
    }
  }
  function createCarHandler() {
    if (step === 4) {
      const formData = new FormData();

      // Append personal details
      if (PersonalDetails) {
        formData.append("role", 1);
        formData.append("name", PersonalDetails.fullName || "");
        formData.append("userId", PersonalDetails.userId || "");
        formData.append("address", PersonalDetails.address || "");
        formData.append("UserEmail", PersonalDetails.email || "");
        formData.append("UserPhoneNumber", PersonalDetails.userPhoneNumber || "");
        formData.append("user_country_code","+"+ PersonalDetails.userCountryCode || "");
        if (editCarID) {
          formData.append("carId", editCarID);
          formData.append(
            "userIdentitycardFront",
            base64Data.identityFront || ""
          );
          formData.append(
            "userIdentitycardBack",
            base64Data.identityBack || ""
          );
        } else {
          formData.append("identityFront", base64Data.identityFront || "");
          formData.append("identityBack", base64Data.identityBack || "");
        }
      }

      // Append car details
      if (carDetails) {
        formData.append("maker", carDetails.carMake || "");
        formData.append("model", carDetails.carModel || "");
        formData.append("carCategory", carDetails.carType || "");
        formData.append("yearOfManufacture", carDetails.manufactureYr || "");
        formData.append("registrationNumber", carDetails.registrationNum || "");
        formData.append("numberOfSeats", carDetails.seat || "");
        formData.append("mileage", carDetails.mileage || "");
        formData.append("fuelType", carDetails.fuelType || "");
        formData.append("motor", carDetails.motor || "");
        formData.append("topSpeed", carDetails.speed || "");
        formData.append("power", carDetails.power || "");
        if (carDetails.carFeature) {
          carDetails.carFeature.forEach((feature) => {
            formData.append("features", feature);
          });
        } else {
          formData.append("features", "");
        }
        // formData.append("features", carDetails.carFeature || '');
        formData.append("carLocation", carDetails.carLocation || "");
        formData.append("lat", location?.lat || "");
        formData.append("long", location?.lng || "");
        formData.append("frontImage", base64Data.carFrontImg || "");
        formData.append("backImage", base64Data.carBackImg || "");
        // formData.append("seatsImage", base64Data.carSeatsImg || "");
        formData.append("interior_image", base64Data.carInteriorImg || "");
        formData.append("dashboard_image", base64Data.carDashboardImg || "");
        formData.append("chasis_image", base64Data.carChassisImg || "");
        formData.append("seat_image", base64Data.carSeatsImg || "");
        formData.append("leftImage", base64Data.carLeftImg || "");
        formData.append("rightImage", base64Data.carRightImg || "");
        formData.append("numberPlateImage", base64Data.numberPlateImg || "");
        // formData.append("gpsAvaiblity", carDetails.gpsAvaiblity || false);
        formData.append("gpsAvaiblity", true);
        formData.append("gpsPayment", gpsPayment?.data?.gpsPayment || 0);
      } else {
        console.log("carDetails not available", carDetails);
      }

      // Append driver details
      if (driverDetails) {
        // formData.append("driverName", driverDetails.fullName || "");
        // formData.append("driverAge", driverDetails.age || "");
        // // formData.append("driverNumber", driverDetails.phone || "");
        // formData.append("driverNumber", driverDetails.driverPhoneNumber || "");
        // formData.append("driver_country_code", "+"+driverDetails.driverCountryCode || "");
        // formData.append("driverEmail", driverDetails.email || "");
        // formData.append("rent", driverDetails.driverRent || "");
        // formData.append("identityCardFrontSide", base64Data.IDfront || "");
        // formData.append("dashboard_image", base64Data.carDashboardImg || "");
        // formData.append("chasis_image", base64Data.carChassisImg || "");
        // // formData.append("disk_image", base64Data.diskImage || "");
        // formData.append("identityCardBackSide", base64Data.IDback || "");
        // formData.append("licenceCard", base64Data.licenceImg || "");
        // formData.append(
        //   "licenceIssueDate",
        //   driverDetails.licenceIssueDate || ""
        // );
        // formData.append(
        //   "licenceExpiryDate",
        //   driverDetails.licenceExpiryDate || ""
        // );
        formData.append("withDriver", driverDetails.withDriver || false);
      } else {
        // console.log("driverDetails not avail.", driverDetails);
      }

      // Append insurance details
      if (carInsurance) {
        formData.append("pricePerDay", carInsurance.pricePerDay || "");
        formData.append("companyName", carInsurance.companyName || "");
        formData.append("policyNumber", carInsurance.policyNumber || "");
        formData.append("expiryDate", carInsurance.expiryDate || "");
        formData.append("disk_image", base64Data.diskImage || "");
        formData.append(
          "insuranceAvailable",
          carInsurance.insuranceAvailable || false
        );
      } else {
        console.log("carInsurance not avail.", carInsurance);
      }
      // if (carDetails.gpsAvaiblity === false) {
      // window.location = `https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${carInsurance.pricePerDay}`
      // } else {
      if (editCarID) {
        dispatch(editCar({ data: formData }));
      } else {
        dispatch(addCar({ data: formData }));
      }
      // }
      // result = false;
      // handleRemove();
      // navigate('/')
      // dispatch(cleanData());
    } else {
      console.log("Step is  (else block api not call)", step);
    }
  }

  return (
    <>
      {noData && !isPaid ? (
        <div className="container-fluid">
          <div className="row justify-content-center mt-5">
            <img
              className="col-lg-4 text-center  w-160 "
              src={noDataImg}
              alt="no data found"
            />
            <h4 className="text-center mt-5 accentColor">
              "No Data Found...."
            </h4>
          </div>
        </div>
      ) : (
        <>
          {isPaid ? (
            <div className="container-fluid">
              <SuccessModal />
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                {/* <img
                  className="col-lg-4 text-center  w-160 "
                  src={noDataImg}
                  alt="no data found"
                />
                <h4 className="text-center mt-5 accentColor">
                  "No Data Found...."
                </h4> */}
                <ClipLoader
                  color="#008080"
                  loading={!isPaid ? true : false}
                  // cssOverride={{ height: "30px" }}
                  size={150}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default GpsPaymentRedirect;
